import _classCallCheck from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { dictonary } from '../utils';
export var PageError = /*#__PURE__*/function (_React$Component) {
  _inherits(PageError, _React$Component);

  var _super = _createSuper(PageError);

  function PageError() {
    var _this;

    _classCallCheck(this, PageError);

    _this = _super.apply(this, arguments);

    _this.prepareMessage = function (message) {
      var dictionary = _this.props.dictionary;

      if (dictionary === null || dictionary === void 0 ? void 0 : dictionary.length) {
        var errIdx = dictionary.findIndex(function (_ref) {
          var error = _ref.error;
          var errRegExp = new RegExp(error, 'g');
          return errRegExp.test(message);
        });

        if (errIdx !== -1) {
          return dictionary[errIdx].message;
        }

        return message;
      }

      var _dictonary$error = dictonary.error,
          VALIDATION = _dictonary$error.VALIDATION,
          INCORRECT = _dictonary$error.INCORRECT,
          REGISTRATION = _dictonary$error.REGISTRATION,
          PHONE_INCORRECT = _dictonary$error.PHONE_INCORRECT,
          PARTNER_NOT_FOUND = _dictonary$error.PARTNER_NOT_FOUND,
          CODE_INCORRECT = _dictonary$error.CODE_INCORRECT;

      if (/property phone has failed the following constraints/.test(message)) {
        return PHONE_INCORRECT;
      }

      if (/NOT_FOUND - partner not found/.test(message) || /NOT_FOUND - account not found/.test(message)) {
        return PARTNER_NOT_FOUND;
      }

      if (/property code has failed the following constraints/.test(message) || /Verification code verification failed/.test(message)) {
        return CODE_INCORRECT;
      }

      if (/validation/.test(message)) {
        return VALIDATION;
      }

      if (/incorrect/.test(message)) {
        return INCORRECT;
      }

      if (/registration/.test(message)) {
        return REGISTRATION;
      }

      return message;
    };

    return _this;
  }

  _createClass(PageError, [{
    key: "render",
    value: function render() {
      var err = this.props.err;

      if (err) {
        return React.createElement("div", {
          className: 'text-center text-danger pt-4 authentication-inner',
          style: {
            position: 'absolute'
          }
        }, this.prepareMessage(err.message));
      }

      return null;
    }
  }]);

  return PageError;
}(React.Component);